import { ColDef } from "ag-grid-community";
import moment from "moment";
import { NormalizedCostWidgetTableDataType } from "@/components/pages/dashboard/components/widgets/normalized-cost-widget/utils/types/types";

export const normalizedCostWidgetTableActualCostComparator: ColDef<NormalizedCostWidgetTableDataType>["comparator"] =
  (_, __, nodeA, nodeB) =>
    (nodeA.data?.regular?.cost ?? 0) > (nodeB.data?.regular?.cost ?? 0)
      ? 1
      : -1;

export const normalizedCostWidgetTableNormalizedCostComparator: ColDef<NormalizedCostWidgetTableDataType>["comparator"] =
  (_, __, nodeA, nodeB) =>
    (nodeA.data?.normalized?.cost ?? 0) > (nodeB.data?.normalized?.cost ?? 0)
      ? 1
      : -1;

export const normalizedCostWidgetTableMonthComparator: ColDef<NormalizedCostWidgetTableDataType>["comparator"] =
  (_, __, nodeA, nodeB) => {
    const firstDate = nodeA.data?.date;
    const secondDate = nodeB.data?.date;

    if (!secondDate) {
      return -1;
    }

    if (!firstDate) {
      return 1;
    }

    const current = moment(firstDate);
    const next = moment(secondDate);

    if (current.isBefore(next)) {
      return -1;
    }

    if (current.isAfter(next)) {
      return 1;
    }

    return 0;
  };
